module.exports = __webpack_public_path__ + "static/media/utility.5b701f04.svg";